
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_1jao5_6",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_1jao5_12",
  "size-small": "awsui_size-small_h11ix_1jao5_37",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_1jao5_41",
  "size-normal": "awsui_size-normal_h11ix_1jao5_55",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_1jao5_59",
  "size-medium": "awsui_size-medium_h11ix_1jao5_73",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_1jao5_77",
  "size-big": "awsui_size-big_h11ix_1jao5_91",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_1jao5_95",
  "size-large": "awsui_size-large_h11ix_1jao5_109",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_1jao5_113",
  "variant-normal": "awsui_variant-normal_h11ix_1jao5_127",
  "variant-disabled": "awsui_variant-disabled_h11ix_1jao5_130",
  "variant-inverted": "awsui_variant-inverted_h11ix_1jao5_133",
  "variant-subtle": "awsui_variant-subtle_h11ix_1jao5_136",
  "variant-warning": "awsui_variant-warning_h11ix_1jao5_139",
  "variant-error": "awsui_variant-error_h11ix_1jao5_142",
  "variant-success": "awsui_variant-success_h11ix_1jao5_145",
  "variant-link": "awsui_variant-link_h11ix_1jao5_148",
  "badge": "awsui_badge_h11ix_1jao5_152"
};
  